import appConfig from '@/config/appConfig.typed';
import flowAvailabilityService from '@/services/aem/flowAvailabilityService';
import connectivityService from '@/services/device/connectivityService';

const isFwuAvailable = (deviceType) => {
    const isBle = connectivityService.isBle();

    return (isBle && isFwuBleAvailable(deviceType)) || isFwuUsbAvailable(deviceType);
};

const isFwuBleAvailable = (deviceType) => {
    return isFwuAvailablePerDevice(deviceType, true);
};

const isFwuUsbAvailable = (deviceType) => {
    return isFwuAvailablePerDevice(deviceType);
};

const isFwuAvailablePerDevice = (deviceType, isBle) => {
    const firmwareUpdateAvailabilityList = appConfig.getFirmwareUpdateAvailabilityList();

    return flowAvailabilityService.isAvailablePerDevice(firmwareUpdateAvailabilityList, deviceType, isBle);
};

export default {
    isFwuAvailable,
    isFwuBleAvailable,
    isFwuUsbAvailable,
};
